import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import MetaHead from '@/Components/MetaHead';
import Button from '@/Components/Button';
import MainHeading from '@/Components/MainHeading';
import SubHeading from '@/Components/SubHeading';
import ContentTitle from '@/Components/ContentTitle';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function Index() {
  const url = 'https://core.fyllo.in/contact';
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [sendBtnActive, setSendBtnActive] = useState(false);

  useEffect(() => {
    const { name, email, phone, subject, message } = formData;
    setSendBtnActive(!!(name && email && phone && subject && message));
  }, [formData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let res = await HandleSendMessage();
    toast.success('Message Sent Successfully');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
    })
  };

  const HandleSendMessage = async () => {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name: formData.name, email: formData.email, mobile: formData.phone, message: formData.message }),
    });
    return response.text();
  };

  return (
    <main className="mx-auto min-h-screen">
      <MetaHead />
      <ToastContainer />
      <section className="py-10 text-center bg-white">
        <MainHeading text="Become a Channel Partner" />
        <SubHeading text="Join us and transform agriculture!" />
      </section>

      <section className="max-w-screen-xl mx-auto p-5 md:p-10 grid grid-cols-1 md:grid-cols-2 gap-12">

        {/* Benefits Section */}
        <div className="bg-gray-200 border rounded-lg shadow-lg p-6">
          <ContentTitle text="Why Choose Us?" />
          <ul className="list-disc list-inside space-y-3 mb-3">
            <li>Fyllo offers cutting-edge precision agriculture solutions, combining IoT devices with advanced software to provide real-time insights tailored to farmer&apos;s needs.</li>
            <li>Our platform empowers farmers by removing guesswork, enabling them to make informed decisions based on real-time data, which enhances both yield and quality of produce.</li>
            <li>With over 100 agronomy models for more than 20 crops, our solutions cater to diverse farming practices, helping farmers optimize their crop management strategies.</li>
            <li>Fyllo is focused on promoting sustainable farming methods, helping farmers maximize productivity while minimizing environmental impact.</li>
          </ul>

          <ContentTitle text="Benefits for Channel Partner" />
          <ul className="list-disc list-inside space-y-3">
            <li>Lucrative margin structure and benefit.</li>
            <li>On field sales and marketing teams to help with liquidation.</li>
            <li>On field installation and support team.</li>
            <li>As a channel partner, you&apos;ll gain access to our innovative precision agriculture products and services, enhancing your portfolio and providing your customers with the best solutions available.</li>
            <li>With a growing demand for precision agriculture solutions, becoming a channel partner opens up new revenue streams and opportunities for business growth.</li>
            <li>Partnering with Fyllo positions you at the forefront of the agriculture technology market, offering your customers advanced tools that drive productivity and efficiency.</li>
          </ul>
        </div>

        {/* Form Section */}
        <div className="bg-white border rounded-lg shadow-lg p-8">
          <ContentTitle text="Get in Touch" />
          <form onSubmit={handleSubmit} className="space-y-6">
            <input
              value={formData.name}
              name="name"
              onChange={handleInputChange}
              placeholder="Your Name"
              className="input input-bordered w-full p-3 rounded-lg shadow-sm focus:ring focus:ring-fyllo-800 transition duration-200"
              required
            />
            <input
              value={formData.email}
              name="email"
              type="email"
              onChange={handleInputChange}
              placeholder="Your Email"
              className="input input-bordered w-full p-3 rounded-lg shadow-sm focus:ring focus:ring-fyllo-800 transition duration-200"
              required
            />
            <input
              value={formData.phone}
              name="phone"
              type="tel"
              onChange={handleInputChange}
              placeholder="Your Phone"
              className="input input-bordered w-full p-3 rounded-lg shadow-sm focus:ring focus:ring-fyllo-800 transition duration-200"
              required
            />
            <input
              value={formData.subject}
              name="subject"
              onChange={handleInputChange}
              placeholder="Subject"
              className="input input-bordered w-full p-3 rounded-lg shadow-sm focus:ring focus:ring-fyllo-800 transition duration-200"
              required
            />
            <textarea
              value={formData.message}
              name="message"
              onChange={handleInputChange}
              placeholder="Your Message"
              className="input input-bordered w-full h-32 p-3 rounded-lg shadow-sm focus:ring focus:ring-fyllo-800 transition duration-200"
              required
            />
            <button
              type="submit"
              className={`bg-fyllo-800 py-3 px-5 text-sm font-medium text-center text-white rounded-lg shadow transition duration-200 hover:bg-fyllo-700 focus:ring-4 focus:outline-none focus:ring-fyllo-300 ${!sendBtnActive ? 'opacity-50 cursor-not-allowed' : ''}`}
              disabled={!sendBtnActive}
            >
              Send Message
            </button>
          </form>
        </div>

      </section>
    </main>
  );
}
